import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';
import classNames from 'classnames';
function CheckBox({
    label,
    id,
    onClick,
    selected,
    isBold,
    name,
    cursorAllowed,
    disabled,
}) {
    return (
        <div className="custom-control custom-checkbox">
            <input
                type="checkbox"
                className="custom-control-input"
                id={id}
                name={name}
                onClick={onClick}
                onChange={(e) => {
                    console.log(e);
                }}
                checked={selected}
                disabled={disabled}
            />
            <label
                className={classNames(
                    'custom-control-label',
                    isBold ? 'bold-label' : '',
                    cursorAllowed ? '' : 'not-allowed',
                )}
                htmlFor={id}
            >
                {label}
            </label>
        </div>
    );
}
CheckBox.propTypes = {
    // To display the label for the checkbox
    label: PropTypes.string,
    // To distinguish the checkbox
    id: PropTypes.string.isRequired,
    // to invoke a function on press/click
    onClick: PropTypes.func,
    // to set default value
    selected: PropTypes.bool,
    // determines if the title is bold
    isBold: PropTypes.bool,
    name: PropTypes.string,
    cursorAllowed: PropTypes.bool,
    disabled: PropTypes.bool,
};
CheckBox.defaultProps = {
    label: null,
    onClick: noop,
    selected: true,
    isBold: false,
    name: null,
    cursorAllowed: true,
    disabled: false,
};
export default CheckBox;
